import { ReturnableTypeEnum } from "./returnable-type-enum";

export const ReturnableTypeLabel = {
  [ReturnableTypeEnum.GOODS_RECEIPT]: "Penerimaan",
  [ReturnableTypeEnum.PURCHASE_INVOICE]: "Faktur Pembelian",
  [ReturnableTypeEnum.NON_INVOICE]: "Non-Faktur",
};
